<!--  -->
<template>
  <footer class="Footer-Component">
    <div class="footer-inner">
      <div class="left">
        <div class="logo">
          <img :src="require('@assets/img/jp/footer-logo.png')" alt="" />
        </div>
        <div class="link-list">
          <nuxt-link :to="localePath('/jp/about-us')" class="link-item"
            >企業情報</nuxt-link
          >
          <nuxt-link :to="localePath('/jp/contact-us')" class="link-item"
            >お問い合わせ</nuxt-link
          >
          <a
            href="https://activity.bigo.tv/live/about/policy.html?lang=ja"
            target="_blank"
            class="link-item"
            >プライバシーポリシー</a
          >
          <a
            href="https://www.youtube.com/channel/UCvLGifpqvKH2RqhC87mDCFQ"
            class="link-ytb"
            target="_blank"
          ></a>
          <a
            href="https://twitter.com/bigolivejapan"
            target="_blank"
            class="link-tw"
          ></a>
        </div>
      </div>
      <div class="copyright">
        {{ `Copyright © ${year} BIGO SERVICE JAPAN K.K. All rights reserved.` }}
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.Footer-Component {
  position: relative;
  width: 100%;
  padding-top: 61px;
  padding-bottom: 61px;
  background: #000;
  z-index: 1;
}

.footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  padding: 0 30px;
  max-width: 1340px;
  margin: 0 auto;
}

.logo {
  margin-bottom: 32px;

  img {
    width: 160px;
    height: 40px;
  }
}

.link-list {
  display: flex;
  align-items: center;

  .link-item {
    margin-right: 24px;
    font-size: 16px;
    color: #fff;
    line-height: 16px;

    &:hover {
      color: rgba(0, 222, 203, 1);
    }
  }
}

.link-ytb {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-right: 24px;
  background-image: url('~@assets/img/jp/ytb-sm.png');
  background-size: 100% 100%;

  &:hover {
    background-image: url('~@assets/img/jp/ytb-sm-hover.png');
  }
}

.link-tw {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-right: 24px;
  background-image: url('~@assets/img/jp/tw-sm.png');
  background-size: 100% 100%;

  &:hover {
    background-image: url('~@assets/img/jp/tw-sm-hover.png');
  }
}

.copyright {
  font-size: 16px;
  color: #8b8c8c;
}

@media screen and (max-width: 850px) {
  .Footer-Component {
    padding-top: 20px;
  }

  .footer-inner {
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .logo {
      text-align: center;
    }
  }

  .link-list .link-item {
    margin: 0 12px;
  }

  .copyright {
    margin-top: 16px;
    text-align: center;
  }
}
</style>
